var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"pricing-count-chip",attrs:{"small":"","outlined":""}},[_vm._v(" "+_vm._s(_vm.label)+": "),_c('strong',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }